import React from 'react';
import CreditDisplay from '../CreditDisplay';
import { useSidebar } from '../../contexts/SidebarContext';

// Hamburger menu icon
const HamburgerIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="3" y1="6" x2="21" y2="6"/>
        <line x1="3" y1="12" x2="21" y2="12"/>
        <line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
);

const TopBar = ({ title, subtitle }) => {
    const { isMobile, toggleMobileMenu } = useSidebar();

    const styles = {
        topBar: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: isMobile
                ? 'var(--space-md) var(--space-lg)'
                : 'var(--space-xl) var(--space-2xl)',
            background: 'var(--bg-card)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            borderBottom: '1px solid var(--border-subtle)',
            position: 'sticky',
            top: 0,
            zIndex: 50,
            gap: 'var(--space-md)',
        },
        left: {
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-md)',
            flex: 1,
            minWidth: 0, // Allow text truncation
        },
        hamburgerBtn: {
            display: isMobile ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'center',
            width: 'var(--touch-target)',
            height: 'var(--touch-target)',
            background: 'transparent',
            border: 'none',
            borderRadius: 'var(--radius-md)',
            cursor: 'pointer',
            color: 'var(--text-secondary)',
            flexShrink: 0,
            transition: 'all var(--duration-fast)',
        },
        hamburgerIcon: {
            width: '24px',
            height: '24px',
        },
        titleContainer: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0, // Allow text truncation
        },
        title: {
            fontFamily: 'var(--font-display)',
            fontSize: isMobile ? '1.25rem' : '1.75rem',
            fontWeight: 700,
            marginBottom: 'var(--space-xs)',
            color: 'var(--text-primary)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        subtitle: {
            color: 'var(--text-tertiary)',
            fontSize: isMobile ? '0.8rem' : '0.9rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        right: {
            display: 'flex',
            alignItems: 'center',
            gap: isMobile ? 'var(--space-sm)' : 'var(--space-lg)',
            flexShrink: 0,
        },
    };

    return (
        <header style={styles.topBar}>
            <div style={styles.left}>
                {/* Hamburger menu button - mobile only */}
                <button
                    style={styles.hamburgerBtn}
                    onClick={toggleMobileMenu}
                    title="Open menu"
                    aria-label="Open navigation menu"
                >
                    <div style={styles.hamburgerIcon}>
                        {HamburgerIcon}
                    </div>
                </button>

                <div style={styles.titleContainer}>
                    <h1 style={styles.title}>{title}</h1>
                    {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
                </div>
            </div>

            <div style={styles.right}>
                {/* Credit Display */}
                <CreditDisplay />
            </div>
        </header>
    );
};

export default TopBar;
